module.exports = __webpack_public_path__ + "a681e7dae1323104fe3a4cd5f0866a63.MP3";